export const CHART_MIN_HEIGHT = 220;
export const EMPTY = "—";
export const FONT = "Inter, -apple-system, BlinkMacSystemFont, sans-serif";
export const LEADS_APP_PATH = "/sales/leads";
export const CRM_STATS_ENDPOINT = "crm/stats/";
export const CRM_TODAY_FOLLOWUPS_URL =
  "crm/followups/?status=DUE_TODAY&page_size=50&ordering=due_date";
export const CRM_OVERDUE_FOLLOWUPS_URL =
  "crm/followups/?status=OVERDUE&page_size=50&ordering=due_date";

export const SOURCE_COLORS = {
  website: "#8b5cf6",
  whatsapp: "#3b82f6",
  email: "#38bdf8",
  referral: "#10b981",
  r2b_referral: "#ec4899",
  instagram: "#ef4444",
  social: "#f97316",
  walk_in: "#10b981",
  google_ads: "#ef4444",
  trade_fair: "#8b5cf6",
  other: "#eab308",
};

export const PIPELINE_COLORS = {
  NEW: "#8b5cf6",
  CONTACTED: "#3b82f6",
  FOLLOW_UP: "#eab308",
  PROPOSAL_SENT: "#a855f7",
  NEGOTIATION: "#f97316",
  CLOSED_WON: "#22c55e",
  CLOSED_LOST: "#ef4444",
};
